module.exports = __webpack_public_path__ + "img/SnippetsIcon.ee9752b4.svg";